
import axios from "axios";
import { store } from "../store";
import { config } from "./CommonURLS";
import Cookies from "js-cookie";
import { InfoAlert } from "./SweetAlerts";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import { getTokenExpiry } from "./CommonServices";




const showLoader = (color = 'primary') => {
  const loader = document.createElement('div');
  loader.className = 'd-flex justify-content-center align-items-center loader-overlay';
  loader.style.position = 'fixed';
  loader.style.top = 0;
  loader.style.left = 0;
  loader.style.width = '100vw';
  loader.style.height = '100vh';
  loader.style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
  loader.innerHTML = `
    <div class="spinner-border text-${color}" role="status" style="width: 3rem; height: 3rem;">
      <span class="visually-hidden">Loading...</span>
    </div>`;
  loader.id = 'globalLoader';
  document.body.appendChild(loader);
};

const hideLoader = () => {
  const loader = document.getElementById('globalLoader');
  if (loader) {
    document.body.removeChild(loader);
  }
};

export const Refreshmethod = async (url, values, method) => {
  const { dispatch } = store;
  var refreshToken = Cookies.get("refreshToken");
  var requestData = { "refreshToken": refreshToken };
  try {
    let URL = config.url.API_URL + "auth/refresh-token";

    const res2 = await axios.post(URL, requestData)
    if (res2.data.responseCode === "01") {

      var decodedToken = jwtDecode(res2?.data?.accessToken);
      var accessTokenTime = new Date(decodedToken.exp * 1000);

      var decoded_refresh = jwtDecode(res2.data.refreshToken);
      var rfTokenTime = new Date(decoded_refresh.exp * 1000);
      const tokenExpiry = getTokenExpiry(res2.data.accessToken);
      const refreshExpiry = getTokenExpiry(res2.data.refreshToken);
      Cookies.set("token", res2.data.accessToken, { expires: accessTokenTime });
      Cookies.set("tokenTime", tokenExpiry);

      // Cookies.set("tokenTime", res2.data.accessTokenExpiration, { expires: accessTokenTime });
      Cookies.set("refreshTokenTime", refreshExpiry);

      Cookies.set("refreshToken", res2.data.refreshToken, { expires: rfTokenTime });
      //  Cookies.set("refreshTokenTime", res2.data.accessTokenExpiration, { expires: rfTokenTime });

      // if (method === "get") {
      //   return CommonAxiosGet(url, values)

      // }
      // else if (method === "post") {
      //   return CommonAxiosPost(url, values)
      // }

      if (method === "get") {
        return await CommonAxiosGet(url, values)

      }
      else if (method === "post") {
        return await CommonAxiosPost(url, values)
      }

    }
    else {
      dispatch({ type: "LOGIN_DETAILS", payload: {} });
      Cookies.remove("token");
      Cookies.remove("tokenTime");
      Cookies.remove("refreshToken");
      Cookies.remove("refreshTokenTime");

    }
  }
  catch (error) {
    console.log("exception::::", error);

  }
}

export const catchErrorMessages = async (err, url, values, method) => {
  // console.log("err.response.status", err.response)
  if (err.response.status === 401) {
    return await Refreshmethod(url, values, method);
  } else if (err.response.status === 500) {
    InfoAlert("Internal Server Error,Try After Sometime", "warning");
  } else if (err.response.status === 404) {
    InfoAlert("Page Not Found", "warning");
  }
  else if (err.response.status === 504) {
    InfoAlert("Timed Out", "warning");
  } else {
    // console.log("catchErrorMessages >>>>>>>>>>> ", err)
  }
}

export const CommonAxiosPost = async (url, values) => {
  let token = Cookies.get("token");

  let refreshToken = Cookies.get("refreshToken");
  showLoader('rgb(66, 44, 2)');
  let data = '';
  if (token === undefined && refreshToken !== undefined) {
    return await Refreshmethod(url, values, "post")
  } else if (token !== undefined) {

    try {
      let res = await axios({
        url: url,
        method: "post",
        data: values,
        headers: { Authorization: "Bearer " + token },
      });
      if (res.status === 200) {
        data = res;
      }
      return data;
    }
    catch (err) {
      return catchErrorMessages(err, url, values, "post");
    }
    finally {
      hideLoader();
    }

  } else if (refreshToken == undefined) {
    // alert('alert commonpost after refresh method')

    // Swal.fire({
    //   title: "Session Expired",
    //   icon: "warning",
    // }).then((res) => {
    //   if (res.isConfirmed) {
    //     window.location.href = '/';
    //   }
    // });




    hideLoader();
  }
};

export const CommonAxiosGet = async (url, values) => {
  const token = Cookies.get("token");
  const refreshToken = Cookies.get("refreshToken");
  showLoader('rgb(66, 44, 2)');
  let data = '';
  if (token === undefined && refreshToken !== undefined) {
    const result = await Refreshmethod(url, "get");
    hideLoader();
    return result;
  } else if (token !== undefined) {
    try {
      const ress = await axios({
        url: url,
        method: 'get',
        headers: { Authorization: "Bearer " + token }
      });

      if (ress.status === 200) {
        data = ress;
      }
      return data;
    } catch (err) {
      return catchErrorMessages(err, url, values, "get")

    } finally {
      hideLoader();
    }
  } else if (refreshToken === undefined || token === undefined) {
    hideLoader();
  }
  // else if (refreshToken === undefined) {
  //   SweetalertRedirectToHome("Your session has expired. Please Login", "warning");
  // }
};


export const CommonAxiosPostLogin = async (url, values) => {
  let data = "";
  try {
    let res = await axios({
      baseURL: config.url.API_URL + "auth/authenticate",
      url: url,
      method: "post",
      data: values,
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {

    if (err.response && err.response.status === 401) {
      data = err.response;
    }
    return data;
  }
};



// import axios from "axios";
// import { config } from "./CommonURLS";
// import axiosInstance from "../../src/Reducers/axiosInstance";


// export const CommonAxiosGet = (url) => {
//   return axiosInstance.get(url);
// };
// export const CommonAxiosPostLogin = async (url, values) => {
//   console.log("DDddd", url)
//   try {
//     return await axios.post(config.url.API_URL + "auth/authenticate" + url, values);
//   } catch (err) {
//     return err.response;
//   }
// };
// export const CommonAxiosPost = (url, data) => {
//   return axiosInstance.post(url, data);
// };